import { FC, useCallback } from 'react';

import { Checkbox, FormControlLabel, FormLabel } from '@mui/material';
import { StyledTextField } from 'components';
import { Container } from 'types';
import { useNewTransaction } from '..';

const ContainerDetails: FC = () => {
  const { container, setContainer } = useNewTransaction();
  const updateContainer = useCallback((p: Partial<Container>) => setContainer(c => ({ ...c, ...p })), [setContainer]);

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>CONTAINER DETAILS</h4>
      </div>
      <div className="card-body grid-4">
        <div>
          <StyledTextField
            fullWidth
            label="SEAL #1"
            value={container.seal0}
            onChange={e => updateContainer({ seal0: e.target.value })}
            data-cy="container-seal-0-input"
          />
        </div>

        <div>
          <StyledTextField
            fullWidth
            label="SEAL #2"
            value={container.seal1}
            onChange={e => updateContainer({ seal1: e.target.value })}
            data-cy="container-seal-1-input"
          />
        </div>
        <div>
          <StyledTextField
            fullWidth
            label="SEAL #3"
            value={container.seal2}
            onChange={e => updateContainer({ seal2: e.target.value })}
            data-cy="container-seal-2-input"
          />
        </div>
        <div>
          <FormControlLabel
            className="form-control"
            control={
              <Checkbox
                checked={!!container.hazard}
                onChange={e => updateContainer({ hazard: e.target.checked })}
                inputProps={{ 'data-cy': 'container-hazard-checkbox' } as any}
              />
            }
            label={<FormLabel sx={{ fontWeight: 'bold' }}>HAZARDS</FormLabel>}
            labelPlacement="start"
          />
        </div>
      </div>
    </div>
  );
};

export default ContainerDetails;
